<template>
    <div class="images">
        <el-tabs v-model="currentTab">
            <el-tab-pane label="未使用" name="using">
                <el-row class="operation">
                    <el-col :span="24">
                        <el-button type="primary" size="mini" @click="addRow(0)">加一张</el-button>
                    </el-col>
                </el-row>
                <el-table v-if="currentTab == 'using'"
                          :data="mediaImages"
                          border>
                    <el-table-column
                            label="图片"
                            width="180">
                        <template slot-scope="scope">
                            <img class="media-image" :src="imageUrl(scope.row.imagePath)"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="图片名称"
                            prop="originalName"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="图片描述"
                            prop="description"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="currentCount"
                            label="当前次数"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="maxCount"
                            label="最大次数"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="创建日期"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            prop="sort"
                            label="排序字段"
                            width="160">
                    </el-table-column>
                    <el-table-column
                            label="操作"
                            width="160">
                        <template slot-scope="scope">
                            <el-button @click="editRow(scope.row)" size="mini">编辑</el-button>
                            <el-button style="display: none" type="primary" size="mini" @click="addRow(scope.$index)">
                                加一张
                            </el-button>
                            <el-popover
                                    placement="right"
                                    width="160"
                                    v-model="scope.row.visible">
                                <p>确定删除吗？</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button size="mini" type="info" @click="scope.row.visible=false">取消</el-button>
                                    <el-button type="danger" size="mini" @click="deleteRow(scope.$index,scope.row)">确定
                                    </el-button>
                                </div>
                                <el-button slot="reference" type="danger" size="mini">
                                    删除
                                </el-button>

                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                            background
                            @current-change="handleCurrentUsingChange"
                            :current-page.sync="pageOfUsing"
                            :page-size="pageSize"
                            layout="prev, pager, next,total"
                            :total="usingTotal">
                    </el-pagination>
                </div>

            </el-tab-pane>
            <el-tab-pane label="已用完" name="used">
                <el-table v-if="currentTab == 'used'"
                          :data="usedImages"
                          border>
                    <el-table-column
                            label="图片"
                            width="180">
                        <template slot-scope="scope">
                            <img class="media-image" :src="imageUrl(scope.row.imagePath)"/>
                        </template>
                    </el-table-column>
                    <el-table-column
                            label="图片名称"
                            prop="originalName"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            label="图片描述"
                            prop="description"
                            width="180">
                    </el-table-column>
                    <el-table-column
                            prop="currentCount"
                            label="当前次数"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="maxCount"
                            label="最大次数"
                            width="120">
                    </el-table-column>
                    <el-table-column
                            prop="createTime"
                            label="创建日期"
                            width="160">
                    </el-table-column>

                    <el-table-column
                            label="操作" style="display:none;">
                        <template slot-scope="scope">
                            <el-button @click="reUse(scope.row)" size="mini" type="success">重新启用</el-button>
                            <el-popover
                                    placement="right"
                                    width="160"
                                    v-model="scope.row.visible">
                                <p>确定删除吗？</p>
                                <div style="text-align: right; margin: 0">
                                    <el-button size="mini" type="info" @click="scope.row.visible=false">取消</el-button>
                                    <el-button type="danger" size="mini" @click="deleteUsedRow(scope.$index,scope.row)">确定
                                    </el-button>
                                </div>
                                <el-button slot="reference" type="danger" size="mini">
                                    删除
                                </el-button>

                            </el-popover>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                            background
                            @current-change="handleCurrentChange"
                            :current-page.sync="page"
                            :page-size="pageSize"
                            layout="prev, pager, next,total"
                            :total="usedTotal">
                    </el-pagination>
                </div>

            </el-tab-pane>
        </el-tabs>
        <el-dialog title="新增图片" :visible.sync="newDialogShow">
            <el-form :model="currentNewRow" :rules="rules" ref="newForm" label-position="right">
                <el-form-item>
                    <el-upload
                            class="upload-demo"
                            action="https://jsonplacfdfsdfeholder.typicode.com/posts/"
                            :on-preview="handlePreview"
                            :with-credentials="true"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :multiple="true"
                            :limit="maxNewFileCount"
                            accept="image/jpeg,image/png"
                            :on-success="handleSuccess"
                            :before-upload="beforeUpload"
                            :on-exceed="handleExceedNew"
                            :on-error="handleError"
                            :file-list="files"
                            :auto-upload="false"
                            list-type="picture">
                        <el-button size="small" type="primary">上传图片</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
                    </el-upload>
                </el-form-item>
                <el-form-item label="图片描述" :label-width="100" prop="description">
                    <el-input type="textarea" :autosize="true" class="input-text" v-model="currentNewRow.description"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="最大次数" :prop="maxCount" :label-width="100"
                              :rules="[{ required: true, message: '最大次数不能为空'},
                              { type: 'number', message: '最大次数必须为数字'}]">
                    <el-input class="input-text" v-model="currentNewRow.maxCount" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="排序字段" :prop="sort" :label-width="100"
                              :rules="[{ required: true, message: '排序字段不能为空，数字越大，排序越后'},
                              { type: 'number', message: '排序字段必须为数字'}]">
                    <el-input class="input-text" v-model="currentNewRow.sort" placeholder="排序字段，数值越大，排序越后"
                              autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="newDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="saveNewImage('newForm')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="修改图片" :visible.sync="editDialogShow">
            <el-form :model="currentEditRow" ref="editForm" :rules="rules" label-position="right">
                <el-form-item>
                    <el-upload
                            class="upload-demo"
                            action="https://jsonplacfdfsdfeholder.typicode.com/posts/"
                            :on-preview="handlePreview"
                            :with-credentials="true"
                            :on-remove="handleRemove"
                            :on-change="handleChange"
                            :multiple="false"
                            :limit="maxEditFileCount"
                            accept="image/jpeg,image/png"
                            :on-success="handleSuccess"
                            :before-upload="beforeUpload"
                            :on-exceed="handleExceedEdit"
                            :on-error="handleError"
                            :file-list="files"
                            :auto-upload="false"
                            list-type="picture">
                        <el-button size="small" type="primary">更换图片</el-button>
                        <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过1M</div>
                    </el-upload>
                </el-form-item>

                <el-form-item label=" 图片描述" :label-width="100" :prop="description">
                    <el-input type="textarea" :autosize="true" class="input-text" v-model="currentEditRow.description"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="最大次数" :prop="maxCount" :label-width="100"
                              :rules="[{ required: true, message: '最大次数不能为空'},
                              { type: 'number', message: '最大次数必须为数字'}]">
                    <el-input v-model="currentEditRow.maxCount" class="input-text" placeholder="排序字段，数值越大，排序越后"
                              autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="排序字段" :prop="sort" :label-width="100"
                              :rules="[{ required: true, message: '排序字段不能为空，数字越大，排序越后'},
                              { type: 'number', message: '排序字段必须为数字'}]">
                    <el-input class="input-text" v-model="currentEditRow.sort" autocomplete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogShow = false">取 消</el-button>
                <el-button type="primary" @click="saveEditImage('editForm')">确 定</el-button>
            </div>
        </el-dialog>
    </div>

</template>
<script>
    import {mediaActivityApi} from "../../common/mediaActivityApi";

    export default {
        name: "images",
        props: {
            mediaActivityId: {
                type: Number
            },
            mpAuthConfigId: {
                type: Number
            }
        },
        computed: {
            imageUrl() {
                return function (imagePath) {
                    return this.domain + "/mediaImg/" + imagePath
                }
            }
        },
        watch: {
            currentTab() {
                var that = this
                if (that.currentTab == 'used') {
                    mediaActivityApi.getMediaActivityImages.call(that, {
                        mpAuthConfigId: that.mpAuthConfigId,
                        mediaActivityId: that.mediaActivityId,
                        used: true,
                        page: that.page,
                        pageSize: that.pageSize
                    }, function (res) {
                        if (res.result.data) {
                            that.usedImages = res.result.data;
                        }
                        if (res.result.totalCount) {
                            that.usedTotal = res.result.totalCount
                        }
                    })
                } else {
                    mediaActivityApi.getMediaActivityImages.call(that, {
                        mpAuthConfigId: that.mpAuthConfigId,
                        mediaActivityId: that.mediaActivityId,
                        used: false
                    }, function (res) {
                        if (res.result.data) {
                            that.mediaImages = res.result.data;
                        }
                    })
                }
            },
            mpAuthConfigId() {
                this.onload();
            },
            mediaActivityId() {
                console.log(this.mediaActivityId)
                this.onload();

            }
        },
        data() {
            return {
                page: 1,
                pageSize: 20,
                usedTotal: 0,
                pageOfUsing: 1,
                usingTotal: 0,
                files: [],
                isUploading: false,
                maxNewFileCount: 10,//上传的时候最大支持10张同时上传
                maxEditFileCount: 1,//编辑的时候，只能一个个编辑，最大文件数是1
                currentEditRow: {},
                currentNewRow: {
                    maxCount: null,
                    sort: null
                },
                currentNewIndex: null,
                mediaImages: [],
                usedImages: [],
                currentTab: 'using',
                file: null,
                editDialogShow: false,
                newDialogShow: false,
                rules: {
                    maxCount: [
                        {required: true, message: '最大次数不能为空'},
                        {type: 'number', message: '最大次数必须为数字'}
                    ],
                    sort: [
                        {required: true, message: '排序字段不能为空，数字越大，排序越后'},
                        {type: 'number', message: '排序字段必须为数字'}
                    ]
                }

            }
        },
        created() {
            this.onload();

        },
        mounted() {
            var that = this;
            if (!that.mpAuthConfigId) {
                that.$message({
                    showClose: true,
                    message: '请先点击最上面开启按钮，再点击右侧箭头，并保存以后再操作。',
                    type: 'error'
                });
            }
        },
        methods: {
            onload() {
                var that = this
                mediaActivityApi.getMediaActivityImages.call(that, {
                    mpAuthConfigId: that.mpAuthConfigId,
                    mediaActivityId: that.mediaActivityId,
                    used: false
                }, function (res) {
                    if (res.result.data) {
                        that.mediaImages = res.result.data;
                    }
                    if (res.result.totalCount) {
                        that.usingTotal = res.result.totalCount
                    }
                })
            },
            editRow(row) {
                this.editDialogShow = true
                this.currentEditRow = row
                this.file = null;
                this.files = []
            },

            reUse(row) {
                var that = this
                mediaActivityApi.reUseMediaImage.call(that, {imageId: row.id, mpAuthConfigId: that.mpAuthConfigId})
            },
            editDoneRow() {

            },
            addRow(index) {
                if (this.mediaImages.length >= 50) {
                    this.$message.error("最大支持上传50个图片");
                    return;
                }
                this.currentNewRow = {}
                this.newDialogShow = true
                this.currentNewIndex = index + 1;
                this.file = null;
                this.files = []
            },
            addDoneRow() {
                this.newDialogShow = false
                this.mediaImages.splice(this.currentNewIndex, 0, this.currentNewRow)
            },
            deleteRow(index, row) {
                var that = this
                mediaActivityApi.deleteMediaActivityImage.call(that, {id: row.id}, function (res) {
                    that.mediaImages.splice(index, 1)
                    row.visible = false
                })
            },

            deleteUsedRow(index, row) {
                var that = this
                mediaActivityApi.deleteMediaActivityImage.call(that, {id: row.id}, function (res) {
                    that.usedImages.splice(index, 1)
                    row.visible = false
                })
            },
            handleChange(file, fileList) {
                console.log("handleChange")
                console.log(file, fileList)
                this.file = file
                this.files = fileList;

            },
            handleRemove(file, fileList) {//移除图片
                console.log("handleRemove")
                console.log(file, fileList);
            },
            handlePreview(file) {//预览图片时调用
                console.log("handlePreview");
                console.log(file);
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },

            checkFile: function (file) {
                if (file == null) return true;
                var fileType = file.raw.type;
                const isJPG = fileType === 'image/png' || fileType === 'image/jpeg' || fileType === 'image/jpg';
                const isLt2M = file.size / 1024 / 1024 < 1;

                if (!isJPG) {
                    this.$message({
                        showClose: true,
                        message: '上传头像图片只能是 jpg,png 格式!',
                        type: 'error'
                    });
                }
                if (!isLt2M) {
                    this.$message({
                        showClose: true,
                        message: '上传图片大小不能超过 1MB!',
                        type: 'error'
                    });
                }
                var pass = isJPG && isLt2M
                return pass;
            },
            beforeUpload(file, filelist) {//文件上传之前调用做一些拦截限制
                console.log("beforeUpload");
                console.log(file);
                this.file = file;
                return this.checkFile(file);
            },
            handleSuccess(res, file) {//图片上传成功
                console.log(res);
                console.log(file);
                this.imageUrl = URL.createObjectURL(file.raw);
            },
            handleError(err, file, fileList) {//图片上传失败调用
                console.log("handleError")
                console.log(err)
            },

            handleExceedNew(file, fileList) {//图片上传超过数量限制
                this.$message({
                    showClose: true,
                    message: '最大支持上传' + this.maxNewFileCount + '张图片',
                    type: 'error'
                });
            },

            handleExceedEdit(file, fileList) {//图片上传超过数量限制
                this.$message({
                    showClose: true,
                    message: '最大支持上传' + this.maxEditFileCount + '张图片',
                    type: 'error'
                });
            },

            sleep(time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            },
            doUploadImages(files, i, sort) {
                var that = this;
                if (i >= files.length) {
                    that.newDialogShow = false
                    that.successMsg("上传成功");
                    return;
                }
                let file = files[i];
                if (that.checkFile(file)) {
                    that.successMsg("正在上传第" + (i + 1) + "张图片:" + file.raw.name)
                    var formData = new FormData();
                    formData.append("file", file.raw)
                    formData.append("maxCount", that.currentNewRow.maxCount)
                    formData.append("description", that.currentNewRow.description)
                    formData.append("mediaActivityId", that.mediaActivityId)
                    formData.append("mpAuthConfigId", that.mpAuthConfigId)
                    formData.append("sort", sort)
                    mediaActivityApi.uploadMediaImage.call(that, formData, function (res) {
                        if (res.result.item) {
                            that.currentNewRow = res.result.item
                            that.currentNewRow.createTime = new Date().format("yyyy-MM-dd hh:mm:ss")
                        }
                        that.mediaImages.splice(that.mediaImages.length, 0, that.currentNewRow)
                        that.sleep(1000).then(() => {
                            // 这里写sleep之后需要去做的事情
                            that.doUploadImages(files, i + 1, Number(sort) + 1)
                        })

                    }, function (res) {
                        that.errorMsg("第" + (i + 1) + "张图片上传出错:" + file.raw.name)
                        that.sleep(1000).then(() => {
                            // 这里写sleep之后需要去做的事情
                            that.doUploadImages(files, i + 1, Number(sort) + 1)
                        })
                    })
                }
            },
            saveNewImage(formName) {
                var that = this
                if (that.file == null) {
                    this.$message({
                        showClose: true,
                        message: '上传文件不能为空',
                        type: 'error'
                    });
                    return false;
                }
                if (!that.currentNewRow.maxCount) {
                    that.$message({
                        showClose: true,
                        message: '最大使用次数必须填写！',
                        type: 'error'
                    });
                    return false;
                }
                if (!that.currentNewRow.sort) {
                    that.$message({
                        showClose: true,
                        message: '排序值必须填写！',
                        type: 'error'
                    });
                    return false;
                }
                if (!that.mpAuthConfigId) {
                    that.$message({
                        showClose: true,
                        message: '请先点击最上面开启按钮，再点击右侧箭头，并保存以后再操作。',
                        type: 'error'
                    });
                    return false;
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        var sort = that.currentNewRow.sort ? that.currentNewRow.sort : that.mediaImages.length + 1;
                        that.doUploadImages(that.files, 0, sort)
                    } else {
                        console.log('error submit!!');
                        return false;
                    }

                });

            },
            saveEditImage(formName) {
                var that = this
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (this.checkFile(that.file)) {
                            var formData = new FormData();
                            if (that.file != null) {
                                formData.append("file", that.file.raw);
                            }
                            formData.append("maxCount", that.currentEditRow.maxCount)
                            formData.append("description", that.currentEditRow.description)
                            formData.append("id", that.currentEditRow.id)
                            formData.append("mediaActivityId", that.mediaActivityId)
                            formData.append("sort", that.currentEditRow.sort)
                            formData.append("mpAuthConfigId", that.mpAuthConfigId)
                            mediaActivityApi.uploadMediaImage.call(that, formData, function (res) {
                                that.editDialogShow = false
                                that.successMsg("更新成功")
                                if (res.result.item) {
                                    that.currentEditRow = res.result.item
                                }
                            }, function (res) {

                            })
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }

                });
            },
            handleCurrentChange() {
                var that = this;
                mediaActivityApi.getMediaActivityImages.call(that, {
                    mediaActivityId: that.mediaActivityId,
                    mpAuthConfigId: that.mpAuthConfigId,
                    used: true,
                    page: that.page,
                    pageSize: that.pageSize
                }, function (res) {
                    if (res.result.data) {
                        that.usedImages = res.result.data;
                    }
                    if (res.result.totalCount) {
                        that.usedTotal = res.result.totalCount
                    }
                })
            },
            handleCurrentUsingChange() {
                var that = this;
                mediaActivityApi.getMediaActivityImages.call(that, {
                    mediaActivityId: that.mediaActivityId,
                    mpAuthConfigId: that.mpAuthConfigId,
                    used: false,
                    page: that.pageOfUsing,
                    pageSize: that.pageSize
                }, function (res) {
                    if (res.result.data) {
                        that.mediaImages = res.result.data;
                    }
                    if (res.result.totalCount) {
                        that.usingTotal = res.result.totalCount
                    }
                })
            }

        }
    }

</script>
<style lang="scss">

    .images {
        .media-image {
            width: 100px;
            height: 100px;
        }

        .el-button {
            margin-left: 10px;
        }

        .input-text {
            width: 400px;
        }

        .el-form-item__label {
            width: 100px;
        }

        .operation {
            .el-button {
                margin-left: 0px;
            }
        }

    }

</style>